import { render, staticRenderFns } from "./Disk.vue?vue&type=template&id=0952bc9a&scoped=true&"
import script from "./Disk.vue?vue&type=script&lang=js&"
export * from "./Disk.vue?vue&type=script&lang=js&"
import style0 from "./Disk.vue?vue&type=style&index=0&id=0952bc9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0952bc9a",
  null
  
)

export default component.exports